import {logger} from "../log/logger";

type BenchmarkTimestamps = {
  songEndMs: number | null;
  firstProgressMs: number | null;
  penultimateProgressMs: number | null;
  scoreModalMs: number | null;
  lastProgressPercent: string | null;
};

const timestamps: BenchmarkTimestamps = {
  songEndMs: null,
  firstProgressMs: null,
  penultimateProgressMs: null,
  scoreModalMs: null,
  lastProgressPercent: null,
};

function reset() {
  timestamps.songEndMs = null;
  timestamps.firstProgressMs = null;
  timestamps.penultimateProgressMs = null;
  timestamps.scoreModalMs = null;
  timestamps.lastProgressPercent = null;
}

function markSongEnd() {
  reset();
  timestamps.songEndMs = performance.now();
}

function markTranscriptionProgress(percent: string) {
  if (!timestamps.songEndMs) return;

  const numericPercent = parseInt(percent);

  if (numericPercent > 0 && numericPercent < 100 && !timestamps.firstProgressMs) {
    timestamps.firstProgressMs = performance.now();
  }

  if (numericPercent > 0 && numericPercent < 100) {
    timestamps.penultimateProgressMs = performance.now();
    timestamps.lastProgressPercent = percent;
  }
}

function markScoreModalShown() {
  if (!timestamps.songEndMs) return;
  timestamps.scoreModalMs = performance.now();
  logResults();
}

function logResults() {
  const {songEndMs, firstProgressMs, penultimateProgressMs, scoreModalMs, lastProgressPercent} = timestamps;

  if (!songEndMs) return;

  const songEndToFirstProgress = firstProgressMs ? firstProgressMs - songEndMs : null;
  const firstProgressToPenultimate = (firstProgressMs && penultimateProgressMs) ? penultimateProgressMs - firstProgressMs : null;
  const penultimateToScoreModal = (penultimateProgressMs && scoreModalMs) ? scoreModalMs - penultimateProgressMs : null;
  const total = scoreModalMs ? scoreModalMs - songEndMs : null;

  const fmt = (ms: number | null) => ms !== null ? `${(ms / 1000).toFixed(2)}s` : "N/A";
  const penultimateLabel = `Penultimate (${lastProgressPercent ?? "?"}%)`;

  logger.pitchDetection.info({
    message: [
      `\n--- Transcription Benchmark ---`,
      `Song end → First progress:           ${fmt(songEndToFirstProgress)}`,
      `First progress → ${penultimateLabel}:  ${fmt(firstProgressToPenultimate)}`,
      `${penultimateLabel} → Score modal:     ${fmt(penultimateToScoreModal)}`,
      `Total (song end → score modal):       ${fmt(total)}`,
      `-------------------------------`,
    ].join('\n'),
  });
}

export const transcriptionBenchmark = {
  markSongEnd,
  markTranscriptionProgress,
  markScoreModalShown,
};
